export class WorkplaceDeleteModalController {
    static $inject = ['configurations', 'close', 'onDelete', 'WorkplaceSegmentService'];
    constructor(configurations, close, onDelete, WorkplaceSegmentService) {
        this.configurations = configurations;
        this.close = close;
        this.onDelete = onDelete;
        this.WorkplaceSegmentService = WorkplaceSegmentService;
    }
    async onContinue() {
        try {
            await this.onDelete();
            this.WorkplaceSegmentService.trackConnectionWorkplaceChatUninstallConfirmed();
        }
        catch (err) {
            console.error(err);
        }
        this.close();
    }
    onCancel() {
        this.WorkplaceSegmentService.trackConnectionWorkplaceChatUninstallCanceled();
        this.close();
    }
}
WorkplaceDeleteModalController.$inject = ['configurations', 'close', 'onDelete', 'WorkplaceSegmentService'];
